import {
  CustomerGender,
  ServiceCancelSettings,
  ServiceCancelPriceSettings,
  ServiceCustomFormsType,
  ServiceDetailType,
  ServiceFormsType,
  ServiceMenuBreakTime,
  ServiceMenuOptionTime,
  ServiceMenuTimeRequired,
  ServicePaidFlag,
  ServicePaymentMethodDto,
  ServiceReservationPeriodFlag,
  ServiceReservationSpecifiedPeriodFlag,
  ServiceReserveStatus,
  ServiceStatus,
  ServiceType as ApiServiceType,
  ServiceViewSeatsLeft,
  ServiceViewType,
  ServiceMenuPublicFlag,
  ContentWebinarDetailsDto,
  UserPlan,
  UserSpecialCommercialLaw,
  FormCustomFormCustomFormsOptionsInner,
  ServiceViewTermFlag,
  FormCustomFormCustomFormsDescriptionJson,
  FormCustomFormCustomFormsExtraJson,
  CapacityStatus,
  ServiceCustomFormsMaximumFile,
  ServiceCustomFormsFileType,
} from "@/apis/clients";
import { IFileUpload } from "@/components/organisms/service-form/CustomFormUploadFile";
import { UiState } from "@/states/types";

export type ServiceType = ApiServiceType;
export const ServiceType = ApiServiceType;

// フォームのスキーマの型
export interface ContentWebinarServiceInfo {
  id: number;
  type: "content-webinar";
  viewType: ServiceViewType;
  name: string;
  serviceDetailIds?: [];
  paid_flag?: ServicePaidFlag;
  paymentmethod?: ServicePaymentMethodDto[];
  details?: ContentWebinarDetailsDto[];
  specialCommercialLaw: UserSpecialCommercialLaw;
  reserveStatus?: ServiceReserveStatus;
  options: ServiceOption[];
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}
export interface InquiryServiceInfo {
  id: number;
  type: "inquiry";
  viewType: ServiceViewType;
  name: string;
  serviceDetailIds?: [];
  paid_flag?: ServicePaidFlag;
  reserveStatus?: ServiceReserveStatus;
  options: ServiceOption[];
  details?: ContentWebinarDetailsDto[];
  specialCommercialLaw?: UserSpecialCommercialLaw;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}

export interface DocumentRequestServiceInfo {
  id: number;
  type: "document-request";
  viewType: ServiceViewType;
  name: string;
  serviceDetailIds?: [];
  paid_flag?: ServicePaidFlag;
  reserveStatus?: ServiceReserveStatus;
  options: ServiceOption[];
  details?: ContentWebinarDetailsDto[];
  specialCommercialLaw?: UserSpecialCommercialLaw;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}
export interface SurveyServiceInfo {
  id: number;
  type: "survey";
  viewType: ServiceViewType;
  name: string;
  serviceDetailIds?: [];
  paid_flag?: ServicePaidFlag;
  details?: ContentWebinarDetailsDto[];
  reserveStatus?: ServiceReserveStatus;
  options: ServiceOption[];
  specialCommercialLaw?: UserSpecialCommercialLaw;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}
export interface EmailNewsLetterSerrviceInfo {
  id: number;
  type: "email-newsletter";
  viewType: ServiceViewType;
  name: string;
  serviceDetailIds?: [];
  paid_flag?: ServicePaidFlag;
  details?: ContentWebinarDetailsDto[];
  reserveStatus?: ServiceReserveStatus;
  options: ServiceOption[];
  specialCommercialLaw?: UserSpecialCommercialLaw;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}
export interface ServiceDetail {
  id: number;
  eventStartAt: Date | undefined;
  eventEndAt: Date | undefined;
  start: Date | undefined;
  end: Date | undefined;
  placeName: string;
  name: string | undefined;
  price: number | undefined;
  maximumNumber: number | undefined;
  remainingReservationCount: number | undefined;
  type: number;
  description: string | undefined;
}

export interface ServiceOption {
  id: number;
  name: string;
  describe: string | undefined;
  description?: string;
  price: number | undefined;
  amount?: number | undefined;
  time: ServiceMenuOptionTime;
  isShowFree?: number;
}

export interface EventSeminarServiceInfo {
  id: number;
  supplierId: number;
  type: "event-seminar";
  viewType: ServiceViewType;
  name: string;
  status: ServiceStatus;
  serviceDetailIds?: [];
  contactName: string;
  contactMail: string;
  contactTel?: string;
  reserveStatus: ServiceReserveStatus;
  reservationAcceptanceSetting: number;
  cancelSettings: number;
  scheduleChangeSettings: number;
  details: ServiceDetail[];
  options: ServiceOption[];
  reservation_period_flag: ServiceReservationPeriodFlag;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  view_seats_left: ServiceViewSeatsLeft;
  paid_flag?: ServicePaidFlag;
  paymentmethod?: ServicePaymentMethodDto[];
  cancel_price_settings?: ServiceCancelPriceSettings;
  specialCommercialLaw: UserSpecialCommercialLaw;
  viewTermFlag: ServiceViewTermFlag;
  disable_past_flag: boolean;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
  capacity_status: CapacityStatus;
  maximum_capacity?: number;
  remaining_capacity: number;
  isShowFree?: number;
}
export interface FormServiceInfo {
  id: number;
  supplierId: number;
  type: "form";
  viewType: ServiceViewType;
  name: string;
  status: ServiceStatus;
  serviceDetailIds?: [];
  contactName: string;
  contactMail: string;
  contactTel?: string;
  reserveStatus: ServiceReserveStatus;
  reservationAcceptanceSetting: number;
  cancelSettings: number;
  scheduleChangeSettings: number;
  details: ServiceDetail[];
  options: ServiceOption[];
  reservation_period_flag: ServiceReservationPeriodFlag;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  view_seats_left: ServiceViewSeatsLeft;
  paid_flag?: ServicePaidFlag;
  paymentmethod?: ServicePaymentMethodDto[];
  cancel_price_settings?: ServiceCancelPriceSettings;
  specialCommercialLaw?: UserSpecialCommercialLaw;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}

export interface CalendarServiceDetail {
  id: number;
  type: ServiceDetailType;
  url: string | undefined;
  placeName: string | undefined;
  zip: string | undefined;
  prefMasterId: number | undefined;
  address1: string | undefined;
  address2: string | undefined;
  maximumNumber: number | undefined;
  remainingReservationCount: number | undefined;
  price: number | undefined;
  viewType: ServiceViewType;
}

export interface ImageData {
  uuid: string;
  url: string;
  name: string;
  size?: number;
}
export interface ServiceMenuDetail {
  id: number;
  name: string;
  imageUrl: string | undefined;
  description: string | undefined;
  timeRequired: ServiceMenuTimeRequired;
  breakTime: ServiceMenuBreakTime;
  color: string | undefined;
  price: number;
  displayOrder: number | undefined;
  options: ServiceOption[];
  publicFlag?: ServiceMenuPublicFlag;
  image?: string;
  requiredTime?: number;
  isShowTime?: number;
  isShowFree?: number;
}

export interface ServiceMenuOptionDetail {
  id: number;
  name: string;
  amount?: number;
  time: ServiceMenuOptionTime;
  description?: string;
}
export interface CalendarServiceInfo {
  id: number;
  supplierId: number;
  status: ServiceStatus;
  type: "calendar";
  name: string;
  reservationPeriodFlag: ServiceReservationPeriodFlag;
  reservationSpecifiedPeriodFlag: ServiceReservationSpecifiedPeriodFlag;
  reservationPeriodStartTime?: string;
  reservationPeriodEndTime?: string;
  contactName: string;
  contactMail: string;
  contactTel?: string;
  cancelSettings: ServiceCancelSettings;
  scheduleChangeSettings: number;
  details: CalendarServiceDetail[];
  menus: ServiceMenuDetail[];
  paid_flag?: ServicePaidFlag;
  paymentmethod?: ServicePaymentMethodDto[];
  cancel_price_settings?: ServiceCancelPriceSettings;
  specialCommercialLaw?: UserSpecialCommercialLaw;
  reserveStatus: ServiceReserveStatus;
  options: ServiceOption[];
  viewType: ServiceViewType;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  viewTermFlag: ServiceViewTermFlag;
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}

export interface SubscriptionServiceDetail {
  id: number;
  name: string;
  price: number;
  isSetCapacity: boolean;
  capacity?: number;
  isSetContractPeriod: boolean;
  contractPeriod?: number;
  isSetFreeTrialPeriod: boolean;
  freeTrialPeriod?: number;
  description?: string;
  maximumNumber: number | undefined;
  remainingReservationCount: number | undefined;
}

export interface SubscriptionServiceInfo {
  id: number;
  type: "subscription";
  viewType: ServiceViewType;
  name: string;
  status: ServiceStatus;
  contactName: string;
  contactMail: string;
  contactTel?: string;
  reserveStatus: ServiceReserveStatus;
  details: SubscriptionServiceDetail[];
  reservation_period_flag: ServiceReservationPeriodFlag;
  reservation_specified_period_flag: ServiceReservationSpecifiedPeriodFlag;
  reservation_period_start_time?: string;
  reservation_period_end_time?: string;
  view_seats_left: ServiceViewSeatsLeft;
  paid_flag?: ServicePaidFlag;
  paymentmethod?: ServicePaymentMethodDto[];
  specialCommercialLaw?: UserSpecialCommercialLaw;
  viewTermFlag: ServiceViewTermFlag;
  capacity_status: CapacityStatus;
  maximum_capacity?: number;
  remaining_capacity: number;
  plan?: UserPlan;
  options?: ServiceOption[];
  gaTag?: string;
  gaCrossDomainTag?: string[];
  gtmId?: string;
}

export type ServiceInfo =
  | EventSeminarServiceInfo
  | ContentWebinarServiceInfo
  | CalendarServiceInfo
  | FormServiceInfo
  | InquiryServiceInfo
  | DocumentRequestServiceInfo
  | EmailNewsLetterSerrviceInfo
  | SurveyServiceInfo
  | SubscriptionServiceInfo;

export interface HoldDate {
  id: number;
  type: ServiceDetailType;
  serviceId: number;
  start: string;
  end: string;
  price: number;
  zip: string;
  prefMasterId: number;
  address1: string;
  address2: string;
  placeName: string;
}

export interface ServiceFormData {
  service: ServiceInfo;
  holdDates: HoldDate[];
  customer: ServiceFormCustomerData[];
  isSubmit?: boolean;
}

export type ServiceFormType = ServiceFormsType;
export const ServiceFormType = ServiceFormsType;

export interface ServiceFormCustomerData {
  type: ServiceFormType;
  serviceFormId: number;
  customForm: CustomForm;
}

type CustomFormType = ServiceCustomFormsType;

export interface CustomForm {
  serviceCustomFormId: number;
  type: CustomFormType;
  label: string;
  isRequired: boolean;
  description?: string;
  descriptionJson?: FormCustomFormCustomFormsDescriptionJson;
  extraJson?: FormCustomFormCustomFormsExtraJson;
  options?: { label: string; value: number | string; id: number | string }[];
  maximumFile?: ServiceCustomFormsMaximumFile;
  fileType?: ServiceCustomFormsFileType;
}

// フォームの入力系の型
export interface ServiceFormInputs {
  service: ServiceFormServiceInputs;
  customer: Partial<ServiceFormCustomerInputs>;
}

export interface ServiceFormServiceInputs {
  detailIds: number[];
  optionIds: number[];
  serviceMenuId: number | undefined;
  serviceMenuReservationDateTime: Date | undefined;
  serviceMenuOptionIds: number[];
  quantity?: {
    [key: string]: number;
  };
}

export type ServiceFormServiceInputKey = keyof ServiceFormServiceInputs;

export interface ServiceFormFields {
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  email: string;
  mailMagazine: boolean;
  subEmail: string;
  tel: string;
  zip1: string;
  zip2: string;
  prefectureId: number;
  address1: string;
  address2: string;
  birthday: string;
  age: string;
  gender: CustomerGender;
  lineId: string;
  facebookId: string;
  twitterId: string;
  instagramId: string;
  companyName: string;
  industryId: number;
  industryOther: string;
  position: string;
  companyHp: string;
  department: string;
  questionnaire: string;
  files: IFileUpload[];
}

export type ServiceFormFieldsKey = keyof ServiceFormFields;

export interface ServiceFormCustomerInputs
  extends ServiceFormFields,
    CustomFormInputs {}

export type ServiceFormCustomerInputKey = keyof ServiceFormCustomerInputs;

export interface CustomFormInputs {
  [key: string]:
    | number
    | string
    | boolean
    | FormCustomFormCustomFormsOptionsInner[]
    | undefined
    | IFileUpload[];
}

export type CustomFormInputKey = keyof CustomFormInputs;

export interface CustomFormOption {
  serviceCustomFormId: number;
  serviceFormId: number;
  formType: ServiceFormType;
  isRequired: boolean;
  value?: string | number;
  selects?: FormCustomFormCustomFormsOptionsInner[];
}

export type FieldValueChangeHandler = <
  Key extends
    | ServiceFormFieldsKey
    | ServiceFormServiceInputKey
    | CustomFormInputKey
    | "files"
    | "serviceMenuOptionIds",
>(
  fieldKey: Key,
  value: Key extends ServiceFormFieldsKey
    ? ServiceFormFields[Key] | undefined
    : Key extends ServiceFormServiceInputKey
    ? ServiceFormServiceInputs[Key] | undefined
    : Key extends "serviceMenuOptionIds"
    ? string[]
    : CustomFormInputs[Key],
) => void;

export const getCustomerInputKeys = (
  serviceFormType: ServiceFormType,
): ServiceFormCustomerInputKey[] => {
  switch (serviceFormType) {
    case ServiceFormType.QUESTIONNAIRE:
      return ["questionnaire"];
    case ServiceFormType.NAME:
      return ["lastName", "firstName"];
    case ServiceFormType.NAME_KANA:
      return ["lastNameKana", "firstNameKana"];
    case ServiceFormType.MAIL_ADDRESS:
      return ["email"];
    case ServiceFormType.MAIL_DELIVERY:
      return ["mailMagazine"];
    case ServiceFormType.TEL:
      return ["tel"];
    case ServiceFormType.ZIP:
      return ["zip1"];
    case ServiceFormType.PREFECTURE:
      return ["prefectureId"];
    case ServiceFormType.ADDRESS1:
      return ["address1"];
    case ServiceFormType.ADDRESS2:
      return ["address2"];
    case ServiceFormType.BIRTHDAY:
      return ["birthday"];
    case ServiceFormType.AGE:
      return ["age"];
    case ServiceFormType.GENDER:
      return ["gender"];
    case ServiceFormType.LINE_ID:
      return ["lineId"];
    case ServiceFormType.FACEBOOK_ID:
      return ["facebookId"];
    case ServiceFormType.TWITTER_ID:
      return ["twitterId"];
    case ServiceFormType.INSTAGRAM_ID:
      return ["instagramId"];
    case ServiceFormType.COMPANY_NAME:
      return ["companyName"];
    case ServiceFormType.INDUSTRY:
      return ["industryId", "industryOther"];
    case ServiceFormType.POSITION:
      return ["position"];
    case ServiceFormType.COMPANY_HP:
      return ["companyHp"];
    case ServiceFormType.DEPARTMENT_NAME:
      return ["department"];
    default:
      return [];
  }
};

// フォーム入力のエラーの型
export type ServiceFormErrors = {
  service: {
    detailIds?: string[];
    optionIds?: string[];
    serviceMenuId?: string[];
    serviceMenuOptionIds?: string[];
    serviceMenuReservationDateTime?: string[];
    quantity?: string[];
    validationError?: string;
    isErrorCapacity?: boolean;
    isShowError?: boolean;
  };
  customer: {
    [key in ServiceFormCustomerInputKey]: string[];
  };
};

export type FormOptions = {
  industries: {
    text: string;
    value: number | string;
  }[];
};

export type FormPayment = {
  paymentIntentId?: string; // Only use for Stripe (Credit card)
  paymentPayPalId?: string; // Only use for PayPal
  billingAmount?: number;
  settlementMethod?: number;
  subscriptionId?: string; // Stripe Subscription ID (sub_xxx) for subscription service types
  settlementAmount?: number;
  couponId?: number;
  couponCode?: string;
  couponDiscountAmount?: number;
  couponEligibleSubtotal?: number;
  couponLabel?: string;
  couponContextKey?: string;
};

export type CardElementFormPayment = {
  paymentMethodId?: string;
};

type FormId = string;
type PageId = number | undefined;
type ClientSecret = string | undefined;
export type ServiceFormAtom = {
  formId: FormId | undefined;
  pageId: PageId;
  isLoading: boolean;
  formData: ServiceFormData;
  inputs: ServiceFormInputs;
  errors: ServiceFormErrors;
  options: FormOptions;
  payment: FormPayment;
  paymentMethod: CardElementFormPayment;
  clientSecret: string | undefined;
  plan: UserPlan;
  draft: {
    inputs: ServiceFormInputs;
    errors: ServiceFormErrors;
  };
  isAgreePolicy: boolean;
};

export type ServiceFormUiState = UiState<
  | {
      status: "NotLoading";
    }
  | {
      status: "Loading";
      formId: FormId;
    }
  | {
      status: "LoadingFailed";
      formId: FormId;
    }
  | {
      [x: string]: any;
      status: "Loaded";
      formId: FormId;
      pageId: PageId;
      formData: ServiceFormData;
      inputs: ServiceFormInputs;
      errors: ServiceFormErrors;
      options: FormOptions;
      payment: FormPayment;
      paymentMethod: CardElementFormPayment;
      clientSecret: ClientSecret;
      plan: UserPlan;
      draft?: {
        inputs: ServiceFormInputs;
        errors: ServiceFormErrors;
      };
      isAgreePolicy: boolean;
    }
>;
